import p from "./highrise1830.mjs";
import a from "./highrise1831.mjs";
import l from "./highrise1832.mjs";
import s from "./highrise1833.mjs";
import m from "./highrise1834.mjs";
function t(o) {
  var e = -1, h = o == null ? 0 : o.length;
  for (this.clear(); ++e < h; ) {
    var r = o[e];
    this.set(r[0], r[1]);
  }
}
t.prototype.clear = p;
t.prototype.delete = a;
t.prototype.get = l;
t.prototype.has = s;
t.prototype.set = m;
export {
  t as default
};
